import React, { useCallback } from 'react';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';
import Tooltip from 'react-tooltip';
import { startCase } from 'lodash';
import { isIE } from '../../../utilities';
import './style.scss';

const Color = ({ contrasty = false, highlight = false, name, onClick = () => {}, theme = 'dark', value }) => {
  const classes = classNames({
    'up-toolbar-color': true,
    contrasty,
    highlight,
    [name]: !!name,
    [theme]: !!theme
  });
  const { t } = useTranslation();

  const style = { backgroundColor: value };

  const handleClick = useCallback(() => onClick(value), [value, onClick]);

  const tooltip = name
    ? t('Color.Tooltip.' + startCase(name).replace(/\s/g, ''), {
        defaultValue: startCase(name)
      })
    : false;

  const tooltipClasses = classNames({
    'up-button-tooltip': true,
    'up-button-tooltip-for-ie': isIE()
  });

  return (
    <div className={classes} name={name} onClick={handleClick} data-tip={tooltip} data-for={tooltip}>
      <div className="up-color-spot" style={style} />
      {tooltip && (
        <Tooltip offset={{ top: -10, left: 0 }} className={tooltipClasses} effect="solid" id={tooltip} place="top" />
      )}
    </div>
  );
};

export default Color;
